"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();

  useEffect(() => {
    const timeout = window.setTimeout(() => router.replace("/"), 3000);
    return () => window.clearTimeout(timeout);
  }, [router]);

  return (
    <main className="grid min-h-dvh place-items-center bg-gray-100 p-6 text-center dark:bg-gray-950">
      <div role="status">
        <p className="text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Page not found
        </p>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
          The page you requested doesn&apos;t exist or may have moved
        </p>
        <p className="mt-6 text-sm text-gray-600 dark:text-gray-300">
          You will be redirected to the main page in 3 seconds.
        </p>
      </div>
    </main>
  );
}